module.exports = __webpack_public_path__ + "static/media/insta-fill@2x.c09625b5.svg";